import { env, useApp } from '@k3/core';
import { ConfigurationT } from '@k3/core/dist/src/lib/types/configuration.interface';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  InputAdornment,
  Stack,
  TextField,
} from '@mui/material';
import { useState } from 'react';
import { useRestartUrl } from './RestartButton';

export const fetchConfiguration = async (code: string) => {
  const response = await fetch(env.apiUrl + '/api/v1.0/app/cfg/' + code);
  if (response.status === 200) {
    const data = await response.json();
    return data as ConfigurationT;
  }
  return null;
};

export const CodeInputDialog = () => {
  const restartUrl = useRestartUrl();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const open = urlParams.get('showCodeDialog') === 'true';
  const app = useApp();

  const [code, setCode] = useState<string>();
  const [foundCode, setFoundCode] = useState<{
    code: string;
    found: boolean;
  } | null>();

  const handleOpenConfiguration = () => {
    window.open(`${window.location.origin}?code=${code}`, '_self');
  };

  const handleSearch = () => {
    if (!code) {
      return;
    }

    fetchConfiguration(code)
      .then((configuration) => {
        setFoundCode({
          code,
          found: Boolean(configuration) && configuration?.appId === app?.id,
        });
      })
      .catch(() => setFoundCode(null));
  };

  const error = foundCode?.found === false && foundCode?.code === code;
  const success = Boolean(
    foundCode && foundCode.found && foundCode.code === code
  );

  return (
    <Dialog open={open}>
      <DialogTitle>Konfiguration öffnen</DialogTitle>
      <DialogContent>
        <DialogContentText gutterBottom>
          Geben Sie hier Ihren Code ein, um eine Konfiguration zu suchen.
        </DialogContentText>
        <Stack direction="row" spacing={2}>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Code"
            type="text"
            fullWidth
            value={code}
            color={success ? 'success' : 'primary'}
            error={error}
            helperText={
              error ? 'Code nicht gefunden' : success ? 'Code gefunden' : ' '
            }
            onChange={(e) => setCode(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="start">
                  <Button
                    variant="contained"
                    onClick={handleSearch}
                    disabled={!code || error || success}
                  >
                    {success ? 'Gefunden' : 'Suchen'}
                  </Button>
                </InputAdornment>
              ),
            }}
          />
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button target="_parent" href={restartUrl}>
          Zurück
        </Button>
        <Button
          variant="contained"
          onClick={handleOpenConfiguration}
          disabled={!(code && foundCode?.found && foundCode?.code === code)}
        >
          Konfiguration öffnen
        </Button>
      </DialogActions>
    </Dialog>
  );
};
